import { render, staticRenderFns } from "./CompaniesWithoutEmployees.vue?vue&type=template&id=2330c0a2"
import script from "./CompaniesWithoutEmployees.vue?vue&type=script&lang=js"
export * from "./CompaniesWithoutEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports